(() => {
  const tracking = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid','gclid','gbraid','wbraid','ttclid','msclkid'];
  let observer;
  let scrollListeners;
  function setup() {
    const source = new URLSearchParams(location.search);
    document.querySelectorAll('[data-ehpl-product]').forEach(link => {
      const target = new URL(link.href,location.origin);
      if (target.origin !== location.origin) return;
      if (target.pathname.replace(/\/$/,'') === '/products/emberhunt-alpaca-boot-socks') target.hash = '';
      tracking.forEach(key => {
        if (source.has(key) && !target.searchParams.has(key)) target.searchParams.set(key,source.get(key));
      });
      link.href = target.href;
    });
    observer?.disconnect();
    scrollListeners?.abort();
    const sticky = document.querySelector('[data-ehpl-sticky]');
    const primary = document.querySelector('[data-ehpl-primary]');
    if (!sticky || !primary) return;
    const updateSticky = () => {
      sticky.hidden = primary.getBoundingClientRect().bottom > 0;
    };
    scrollListeners = new AbortController();
    document.addEventListener('scroll',updateSticky,{passive:true,capture:true,signal:scrollListeners.signal});
    window.addEventListener('resize',updateSticky,{passive:true,signal:scrollListeners.signal});
    observer = new IntersectionObserver(updateSticky,{threshold:0});
    observer.observe(primary);
    updateSticky();
  }
  setup();
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('shopify:section:unload',setup);
  document.addEventListener('shopify:section:reorder',setup);
  document.addEventListener('shopify:block:select',event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
})();

